import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IframeModuleService } from './iframe-module.abstract.service';

@Injectable()
export class IframeModuleServiceImpl implements IframeModuleService {
    public baseUrl: string = environment.API_GATEWAY_URL;

    constructor(private http: HttpClient) {}

    getConfiguration(): Observable<any> {
        return this.http
            .get(`${this.baseUrl}/configurations/iframemodules`, {
                headers: new HttpHeaders({
                    'x-organisation': 'ALL',
                }),
            })
            .pipe(map((response) => response as any));
    }
}

export const IFRAME_MODULE_SERVICE_PROVIDER = {
    provide: IframeModuleService,
    useClass: IframeModuleServiceImpl,
};
